var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    viewBox: "-27 24 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 74,
    fill: "#F5EEE5",
    r: 50
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,99.9l27.9,7.7c3.2,1.1,5.7,3.5,7.1,6.6v9.8H-27v-9.8c1.3-3.1,3.9-5.5,7.1-6.6L8,99.9V85h30V99.9z",
    fill: "#E6C19C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27,82H73v42H-27V82z M23,112c11,0,20-6.3,20-14s-9-14-20-14S3,90.3,3,98S12,112,23,112z",
    fill: "#E6A422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,102c-1.7,0-3.9-0.4-5.4-1.1c-1.7-0.9-8-6.1-10.2-8.3c-2.8-3-4.2-6.8-4.6-13.3c-0.4-6.5-2.1-29.7-2.1-35c0-7.5,5.7-19.2,22.1-19.2l0.1,0c16.5,0.1,22.1,11.7,22.1,19.2c0,5.3-1.7,28.5-2.1,35c-0.4,6.5-1.8,10.2-4.6,13.3c-2.1,2.3-8.4,7.4-10.2,8.3C26.9,101.6,24.7,102,23,102z",
    fill: "#D4B08C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,82C10.3,82,0,89.4,0,98.5S10.3,115,23,115s23-7.4,23-16.5S35.7,82,23,82z M23,111c-10.5,0-19-6-19-13.5S12.5,84,23,84s19,6,19,13.5S33.5,111,23,111z",
    fill: "#D98C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,98c-1.5,0-3.5-0.3-4.8-0.9c-1.6-0.7-7.2-4.6-9.1-6.3c-2.5-2.3-3.8-5.1-4.2-10S3,58.5,3,54.5C3,48.8,8.1,40,23,40C37.9,40,43,48.8,43,54.5c0,4-1.5,21.5-1.9,26.4s-1.6,7.7-4.2,10c-1.9,1.7-7.6,5.6-9.1,6.3C26.5,97.7,24.5,98,23,98z",
    fill: "#F2CEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,85.5c-1.9,2-5.2,3-8.1,2.4c-2.7-0.6-4.7-2-5.7-4.3",
    fill: "none",
    stroke: "#A3705F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 69,
    fill: "#291F21",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 69,
    fill: "#291F21",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,66c0,0,1.1-3,6.1-3c3.4,0,5.4,1.5,6.4,3",
    fill: "none",
    stroke: "#CC9872",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1,66c0,0-1.1-3-6.1-3c-4.8,0-7,3-7,5c0,1.9,0,9,0,9",
    fill: "none",
    stroke: "#BB8660",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8,72.2c0,0,0.8-6.3,3.7-7.2c0.4-1.8,1.5-7,1.5-9.9s-0.3-5.7-1.9-8.1c-1.8-2.6-5.6-4.1-7.6-4.1c-2.3,1.4-7.7,4.6-9.4,6.5c-0.9,1,0.4,1.8,0.4,1.8s1.2-0.5,1.7-0.6c2.5-0.7,8-1.2,9.7,1.3C42,54.9,42,63.7,42,65C42,66.2,41.8,72.2,41.8,72.2z",
    fill: "#452228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,65c2.9,1,3.7,7.2,3.7,7.2S4,66.2,4,65c0-1.6,0.2-9.1,3.4-12.7c3.6-4,8.4-5.3,11.1-3.5c1.4,0.9,6.1,5.5,11.1,1.7c3-2.3,8.5-7.5,8.5-7.5s-2.9-8.9-16.1-7.9c-5.6,0.5-11.8-0.9-11.8-0.9s-0.1,2.5,0.9,3.8C2.8,40.4,0.1,46.4-0.7,51c-0.2,0.9-0.3,1.8-0.3,2.7c0,0.5,0,1,0,1.4C-1,58,0.1,63.1,0.5,65z",
    fill: "#6B363E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.69932dbe3d14cf1930144681c5e04333.svg";
export { ForwardRef as ReactComponent };